<div mat-dialog-title class="dialog-header">
  <span>Logs of {{chargepoint.id}}</span>
  <div class="spacer"></div>
  <button mat-icon-button (click)="close()" color="secondary">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <app-chargepoint-traces [chargepoint]="chargepoint"></app-chargepoint-traces>
</mat-dialog-content>
